import Decimal from "decimal.js";

export function formatDisplayAmount(currency, amount) {
  if (!currency || !amount) {
    return '-'
  }

  return new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: currency,
    currencyDisplay: "narrowSymbol"
  }).format(amount ? (amount).toFixed(2) : 0.00)
}

export function displayAmount(currency, amount) {

  if (!currency || !amount) {
    amount = 0.00;
  }

  return new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: currency,
    currencyDisplay: "narrowSymbol"
  }).format(amount ? (amount / 100).toFixed(2) : 0.00)
}

export function displayAmountNoSymbol(currency, amount) {
  if (!currency || !amount) {
    amount = 0.00;
  }

  const value = amount ? (amount / 100).toFixed(2) : 0.00;

  return new Intl.NumberFormat('en-ZA', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
}


export function roundHalfUp(value, decimals = 2) {
  const amount = new Decimal(value);
  return amount.toDecimalPlaces(decimals);
}

export function fromCents(value, decimals = 2) {
  const amount = new Decimal(value / 100);
  return amount.toDecimalPlaces(decimals);
}

export function toCents(value, decimals = 2) {
  const amount = new Decimal(value * 100);
  return amount.toDecimalPlaces(decimals);
}



// WEBPACK FOOTER //
// ./src/utils/money.js